import React, { Component } from 'react'
import * as styles from './nav.module.css'

import NavLink from './NavLink'

export default class Nav extends Component {
  render() {
    return (
      <nav role="navigation" className={styles.nav}>
        <ul className={styles.ul}>
          <NavLink className={styles.li} href={'/about/'}>
            About Me
          </NavLink>
          <NavLink className={styles.li} href={'/'}>
            Blog
          </NavLink>
          <NavLink className={`${styles.li} phone-hidden`} href={'/now/'}>
            Now
          </NavLink>
          <NavLink className={styles.li} href={'/books/'}>
            Books
          </NavLink>
          <NavLink
            className={styles.li}
            href={'https://www.youtube.com/channel/UCCbO782lk1tvKgc7uU14mZQ'}
            target="_blank"
          >
            Videos
          </NavLink>
          <NavLink className={styles.li} href={'/notes/'}>
            Notes
          </NavLink>
          <NavLink className={`${styles.li} phone-hidden`} href={'/speaking/'}>
            Speaking
          </NavLink>
          <NavLink className={styles.li} href={'/projects/'}>
            Projects
          </NavLink>
          <NavLink className={styles.li} href={'/articles/'}>
            Best Of
          </NavLink>
          <NavLink className={styles.li} href={'/newsletter/'}>
            Newsletter
          </NavLink>
          <NavLink className={styles.li} href={'/reading/'}>
            Reading
          </NavLink>
          <NavLink className={`${styles.li} phone-hidden`} href={'/podcasts/'}>
            Listening
          </NavLink>
          <NavLink className={styles.li} href={'/blog/archives'}>
            Archive
          </NavLink>
        </ul>
      </nav>
    )
  }
}
